import React, { createContext } from "react"
import { HistoricoFechamentosInicial } from "../models/historicoFechamentosModel"
import type { HistoricoFechamentosModel } from "../models/historicoFechamentosModel"
import type { HistoricoFechamentosActions } from "./historicoFechamentosActions"

type HistoricoFechamentosContextType = {
    dados: HistoricoFechamentosModel
    dispatch: React.Dispatch<HistoricoFechamentosActions>
    erroCarregamento: string | null
    dataInicio: string
    dataFim: string
    setDataInicio: (data: string) => void
    setDataFim: (data: string) => void
    recarregar: (dataInicio?: string, dataFim?: string) => Promise<void>
}

export const HistoricoFechamentosContext = createContext<HistoricoFechamentosContextType>({
    dados: HistoricoFechamentosInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    dataInicio: "",
    dataFim: "",
    setDataInicio: () => undefined,
    setDataFim: () => undefined,
    recarregar: async () => undefined,
})
